__turbopack_context__.v({
  "blok-big-title": "FAQsBlok-module__WBqOWa__blok-big-title",
  "blok-subtitle": "FAQsBlok-module__WBqOWa__blok-subtitle",
  "blok-title": "FAQsBlok-module__WBqOWa__blok-title",
  "root": "FAQsBlok-module__WBqOWa__root",
  "title": "FAQsBlok-module__WBqOWa__title",
});
